var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2PowerSupplyConverter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 32a13 13 0 00-11-12.79V7h-4v12.21A13 13 0 0026.47 38 13 13 0 0036 56.79V73h4V56.79A13 13 0 0049.55 38 12.91 12.91 0 0051 32zM38 53a9 9 0 01-8.69-11.29 12.92 12.92 0 0017.39 0A9 9 0 0138 53zm-6.72-15a9 9 0 0113.45 0 9 9 0 01-13.45 0zm15.42-3.68a12.92 12.92 0 00-17.39 0 9 9 0 1117.39 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Power_Supply_Converter.547e4c73.svg";
export { SvgA2PowerSupplyConverter as ReactComponent };